import { render } from "./CreateValidationPeriod.vue?vue&type=template&id=a3885896&scoped=true"
import script from "./CreateValidationPeriod.vue?vue&type=script&lang=js"
export * from "./CreateValidationPeriod.vue?vue&type=script&lang=js"

import "./CreateValidationPeriod.vue?vue&type=style&index=0&id=a3885896&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3885896"]])

export default __exports__